vec3 effect(vec2 uv)
{
    vec2 offset = vec2(uAmount * 0.02, 0.0);
    return vec3(
        sampleCam(uv + offset).r,
        sampleCam(uv).g,
        sampleCam(uv - offset).b
    );
}
